import { comparisonData } from "@/mocks/homeContent";

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Mulebuy Spreadsheet vs Alternatives
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See how the Mulebuy Spreadsheet system stacks up against traditional shopping and direct platform sourcing.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-secondary-100">
                <th className="px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  Feature
                </th>
                <th className="px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold text-primary-700 whitespace-nowrap">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-file-list-3-line"></i>
                    Mulebuy Spreadsheet
                  </span>
                </th>
                <th className="px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  Traditional Shopping
                </th>
                <th className="px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  1688 Direct
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`${
                    i % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                  } hover:bg-accent-50/50 transition-colors`}
                >
                  <td className="px-4 md:px-6 py-3 text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {row.feature}
                  </td>
                  <td className="px-4 md:px-6 py-3 text-xs md:text-sm text-primary-700 font-medium">
                    {row.mulebuy}
                  </td>
                  <td className="px-4 md:px-6 py-3 text-xs md:text-sm text-foreground-600">
                    {row.traditional}
                  </td>
                  <td className="px-4 md:px-6 py-3 text-xs md:text-sm text-foreground-600">
                    {row.direct1688}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}